import createFlags from "flag";
import { observable } from "mobx";
import type { GadgetFlags } from "state-trees/src/GadgetFlags";
import { ClientSideDefaultFlags } from "state-trees/src/GadgetFlags";
export { Flag, FlagsProvider, useFlag, useFlags };

declare global {
  interface Window {
    GadgetFlags: GadgetFlags;
  }
}

const { FlagsProvider, Flag, useFlag, useFlags } = createFlags<GadgetFlags>();
export const CurrentFlags: GadgetFlags = observable(typeof window === "undefined" ? ClientSideDefaultFlags : window.GadgetFlags);

if (typeof window !== "undefined") {
  /** Utility for setting flag values in tests */
  (window as any).mockFlags = (newFlags: Partial<GadgetFlags>) => {
    for (const key of Object.keys(newFlags) as Array<keyof GadgetFlags>) {
      const newValue = newFlags[key];
      const existing = CurrentFlags[key];
      if (newValue !== null && typeof newValue === "object" && existing !== null && typeof existing === "object") {
        // Replace the top-level property with a new merged object so MobX fires a change
        (CurrentFlags as any)[key] = { ...existing, ...newValue };
      } else {
        (CurrentFlags as any)[key] = newValue;
      }
    }
  };
}
